import React, { useEffect, useRef } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import firebase from './../../../firebase';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Importer le style de Quill
import ImageResize from 'quill-image-resize-module-react';
import { API_URL } from 'constants';

const NewEmail = () => {
  const [validated, setValidated] = React.useState(false);
  const [formd, setFrom] = React.useState({});
  const [l, setL] = React.useState(false);
  const [mailingsList, setMailingsList] = React.useState([]);
  const [valueMailList, setValueMailList] = React.useState([]);
  const [message, setMessage] = React.useState('');
  const [messageEn, setMessageEn] = React.useState('');
  const quillRef = useRef(null);
  const quillRefEn = useRef(null);
  // Enregistrer le module d'image
  ReactQuill.Quill.register('modules/imageResize', ImageResize);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      return;
    }
    // console.log('form', formd);
    if (formd.mailingsList?.length === 0) {
      toast.warning("Une liste d'emailing minimum est requis");
      return;
    }
    if (message.length === 0) {
      toast.warning("Un message est requis");
      return;
    }
    if (formd.title?.length === 0) {
      toast.warning("Un Titre est requis");
      return;
    } 
    if (confirm("Je confirme vouloir envoyé ce mail a tout les contacts de liste sélectionné ?")) {
      setValidated(true);
      setL(true);
      fetch(`${API_URL}sendEmailList`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({send_locataire: formd?.send_locataire || false, send_owner: formd?.send_owner || false, list: formd.mailingsList, message: message, messageEn: messageEn, title: formd?.title, uid: firebase.auth().currentUser.uid }),
      }).then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setValidated(false);
            setL(false);
            toast.success("Email envoyé avec succès.");
          }
        })
        .catch((err) => {
          setValidated(false);
          setL(false);
          toast.error("Une erreur s'est produite" + err);
        });
    }
  };

  const handleChange = e => {
    let d = { ...formd };
    d[e.target.name] = e.target.value;
    setFrom(d);
  };

  const loadMailingsList = () => {
    firebase.firestore().collection('mailingslist').get().then((snap) => {
      let s = [];
      snap.forEach((d) => {
        var l = d.data();
        if (!l?.delete) {
          const dr = { value: d.id, label: `${l?.title}` };
          s.push(dr);
        }
      });
      setMailingsList(s);
    }).catch((error) => {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    });
  };

  useEffect(() => {
    loadMailingsList();
  }, []);



  // Fonction qui vérifie si le texte contient du HTML
  function isHTML(str) {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1); // Vérifie si un élément HTML est présent
  }
  const insertHtml = async () => {
    const html = await navigator.clipboard.readText();
    const isHtml = isHTML(html);
    if (html && isHtml) {
      const quill = quillRef.current.getEditor();
      quill.clipboard.dangerouslyPasteHTML(0, html); // Insère le HTML à l'index 0
      const quillEn = quillRefEn.current.getEditor();
      quillEn.clipboard.dangerouslyPasteHTML(0, html); // Insère le HTML à l'index 0
    } else {
      toast.error('Ceci n\'est pas un code HTML');
    }

  };

  return (
    <FalconComponentCard>
      <FalconComponentCard.Header title="Nouveau mail (envoie groupé)" light={false} noPreview={true} />
      <FalconComponentCard.Body>
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Form.Group as={Col} md="3" controlId="title">
              <Form.Label>Titre (Sujet du mail)</Form.Label>
              <Form.Control
                onChange={handleChange}
                required
                name="title"
                type="text"
                placeholder="Votre sujet du mail.."
              />
              <Form.Control.Feedback type="invalid">
                Veuillez indiquez votre titre.
              </Form.Control.Feedback>
              <Form.Control.Feedback>Parfait!</Form.Control.Feedback>
            </Form.Group>

            <Form.Group as={Col} md="3" controlId="mailingsList">
              <Form.Label>Liste d'emailing</Form.Label>
              <Select
                autocomplete="off"
                closeMenuOnSelect={false}
                options={mailingsList}
                placeholder='Choisir...'
                isMulti
                classNamePrefix="react-select"
                value={valueMailList}
                onChange={value => {
                  setValueMailList(value);
                  let d = { ...formd };
                  d.mailingsList = value;
                  setFrom(d);
                }}
              />
            </Form.Group>


            <Form.Group style={{marginTop:37}} className="mb-3" as={Col} md="2">
              <Form.Check
                type="switch"
                name="send_owner"
                onChange={value => {
                  let d = { ...formd };
                  d.send_owner = value.target.checked;
                  setFrom(d);
                }}
                label="Envoyer aux propriétaires"
              />

            </Form.Group>

            <Form.Group style={{marginTop:37}} className="mb-3" as={Col} md="2">
              <Form.Check
                type="switch"
                name="send_locataire"
                onChange={value => {
                  let d = { ...formd };
                  d.send_locataire = value.target.checked;
                  setFrom(d);
                }}
                label="Envoyer aux locataires"
                checked={formd.is_locataire}
              /> 
            </Form.Group>


            <Form.Group style={{marginTop:37}} as={Col} md="2" >
              <Button variant="secondary" className="ms-2" onClick={insertHtml}>
                Coller HTML
              </Button></Form.Group>

            <Form.Group as={Col} md="10" controlId="message">
              <Form.Label>Message (français)</Form.Label>
              <ReactQuill
                ref={quillRef}
                value={message}
                onChange={setMessage}
                modules={{
                  toolbar: [
                    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    ['image', 'code-block'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    ['clean']
                  ],
                  imageResize: {
                    modules: ['Resize', 'DisplaySize']
                  }
                }}
                style={{ height: '400px' }}
                placeholder="Écrivez votre message ici..."
              />
            </Form.Group>

            <Form.Group as={Col} md="10" controlId="messageEn" style={{ marginTop: 40 }}>
              <Form.Label>Message (anglais)</Form.Label>
              <ReactQuill
                ref={quillRefEn}
                value={messageEn}
                onChange={setMessageEn}
                modules={{
                  toolbar: [
                    [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    ['image', 'code-block'],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    ['clean']
                  ],
                  imageResize: {
                    modules: ['Resize', 'DisplaySize']
                  }
                }}
                style={{ height: '400px' }}
                placeholder="Write your message here..."
              />
            </Form.Group>
          </Row>
          <Button style={{ marginTop: 40 }} type="submit" disabled={l}>{l ? 'Chargement' : 'Envoyer'}</Button>
        </Form>
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
};

export default NewEmail;